import React from 'react'

import { Box } from '@material-ui/core'

const Badge = ({ number, styles }) => {
  return <Box className={styles}>{number}</Box>
}

export default Badge
